import { render, staticRenderFns } from "./CatalogSearchBar.vue?vue&type=template&id=894f45f8&scoped=true"
import script from "./CatalogSearchBar.vue?vue&type=script&lang=js"
export * from "./CatalogSearchBar.vue?vue&type=script&lang=js"
import style0 from "./CatalogSearchBar.vue?vue&type=style&index=0&id=894f45f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894f45f8",
  null
  
)

export default component.exports